import styled from '@emotion/styled';

import AvailableRecurlyAccountsTable from 'account/components/CreateAccountModal/AvailableRecurlyAccountsTable/Table';

const FoundAccountsHeader = styled.div`
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 10xp;
  padding-bottom: 12px;
`;

const AccountTypeHeader = styled.div`
  font-size: 16px;
  padding-bottom: 24px;
  padding-top: 24px;
`;

function View({ selectedRow, onRowClick }) {
  return (
    <>
      <FoundAccountsHeader>
        Unmatched accounts found in Recurly:
      </FoundAccountsHeader>
      <AvailableRecurlyAccountsTable selectedRow={selectedRow} onRowClick={onRowClick} />
      <AccountTypeHeader>
        After picking an unmatched account from Recurly above, select an account type.
      </AccountTypeHeader>
    </>
  );
}

function Model({ selectedRow, onRowClick }) {
  const hookProps = {
    selectedRow,
    onRowClick,
  };

  return (
    <View
      {...hookProps}
    />
  );
}

export default Model;
export { View };
